module.exports = __webpack_public_path__ + "img/logo-white.9817c327.png";